<template>
    <div class="login-page">
        <div class="login-page__bg"></div>
        <div class="login-box">
            <div class="card card-outline card-primary">
                <div class="card-header text-center">
                    <a href="javascript:void(0)" class="h3">DBHUB Viewer for Kintone</a>
                </div>
                <div class="text-center mt-2">
                    <img class="logo-login" src="../../assets/img/consulting.svg" alt="" />
                </div>
                <div class="card-body">
                    <form>
                        <div class="mb-3">
                            <label for="email" class="mb-0">{{ $t('pageLogin.email') }}<span class="text-danger"> *</span></label>
                            <div class="input-group">
                                <input
                                    type="text"
                                    id="email"
                                    v-model="email"
                                    readonly
                                    @keydown="validate('email')"
                                    @keyup="validate('email')"
                                    class="form-control"
                                    :class="{ 'input-valid': errorInfo.email }"
                                    :placeholder="$t('pageLogin.email')"
                                />
                                <div class="input-group-append">
                                    <div class="input-group-text">
                                        <span class="fas fa-envelope"></span>
                                    </div>
                                </div>
                            </div>
                            <error-message-auth :error="errorInfo.email"></error-message-auth>
                        </div>
                        <div class="mb-3">
                            <label for="password" class="mb-0">{{ $t('pageLogin.password') }}<span class="text-danger"> *</span></label>
                            <div class="input-group input-group__password">
                                <input
                                    :type="isShowPassword ? 'text' : 'password'"
                                    id="password"
                                    v-model="password"
                                    @keydown="validate('password')"
                                    @keyup="validate('password')"
                                    class="form-control"
                                    :class="{ 'input-valid': errorInfo.password }"
                                    :placeholder="$t('pageLogin.password')"
                                />
                                <div class="input-group-append">
                                    <div class="input-group-text">
                                        <span class="fas fa-lock"></span>
                                    </div>
                                </div>
                                <span class="password-icon">
                                    <i @click="isShowPassword = !isShowPassword" class="fas" :class="{ 'fa-eye': isShowPassword, 'fa-eye-slash': !isShowPassword }"></i>
                                </span>
                            </div>
                            <error-message-auth :error="errorInfo.password"></error-message-auth>
                        </div>
                        <div class="mb-3">
                            <label for="password" class="mb-0">{{ $t('pageLogin.reTypePassword') }}<span class="text-danger"> *</span></label>
                            <div class="input-group input-group__password">
                                <input
                                    :type="isShowRePassword ? 'text' : 'password'"
                                    id="passwordConfirm"
                                    v-model="rePassword"
                                    @keydown="validate('rePassword')"
                                    @keyup="validate('rePassword')"
                                    @keyup.enter="handleChangePassword"
                                    class="form-control"
                                    :class="{ 'input-valid': errorInfo.rePassword }"
                                    :placeholder="$t('pageLogin.reTypePassword')"
                                />
                                <div class="input-group-append">
                                    <div class="input-group-text">
                                        <span class="fas fa-lock"></span>
                                    </div>
                                </div>
                                <span class="password-icon">
                                    <i @click="isShowRePassword = !isShowRePassword" class="fas" :class="{ 'fa-eye': isShowPassword, 'fa-eye-slash': !isShowPassword }"></i>
                                </span>
                            </div>
                            <error-message-auth :error="errorInfo.rePassword"></error-message-auth>
                        </div>
                    </form>

                    <div class="social-auth-links text-center mt-4 mb-3">
                        <button v-loading="isLoading" :disabled="isLoading" class="btn btn-block btn-primary" @click="handleChangePassword">
                            {{ $t('button.settingBtn') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { APP_TOKEN_NAME } from '../../config/constants';
import { generateStorageKey, validDuplicator, validEmail, validPassword, validRequired } from '../../utils';
import ErrorMessageAuth from '@/views/auth/errorMessageAuth';
import { mapState } from 'vuex';

export default {
    name: 'login',
    components: { ErrorMessageAuth },
    data() {
        return {
            email: '',
            password: '',
            rePassword: '',
            isShowPassword: false,
            isShowRePassword: false,
            tokenSettingPassword: '',
            isLoading: false,
            errorInfo: {
                email: '',
                password: '',
                rePassword: ''
            }
        };
    },
    computed: {
        ...mapState('auth', ['userInfo'])
    },
    mounted() {
        let currentUrl = window.location.href;
        let params = new URL(currentUrl).searchParams;
        if (params.get('token')) {
            localStorage.setItem(APP_TOKEN_NAME, '');
            this.$cookies.set(generateStorageKey(APP_TOKEN_NAME), '');
            this.tokenSettingPassword = params.get('token');
            this.getSettingPassword(params.get('token'));
        }
    },
    methods: {
        goPath(path) {
            if (path) {
                this.$router.push(path);
            }
        },
        getSettingPassword(token) {
            let successCallback = (response) => {
                localStorage.removeItem(APP_TOKEN_NAME);
                let { user } = response.data.data;
                this.email = user.email;
                if (user['setting-password'] && user['setting-password'] === 'true') {
                    // this.$router.push('/login')
                }
            };
            let errorCallback = () => {
                localStorage.removeItem(APP_TOKEN_NAME);
                this.$router.push('/login');
            };
            let payload = {
                token: token,
                successCallback,
                errorCallback
            };
            this.$store.dispatch('auth/verifySettingPassword', payload);
        },
        handleChangePassword() {
            let check = this.validate();
            if (check) {
                if (this.isLoading) return;
                this.isLoading = true;
                let successCallback = () => {
                    this.$router.push('/login');
                    this.$store.commit('noticeSystem/SET_MESSAGE', {
                        isShowMessage: true,
                        type: 'success',
                        message: this.$t('pageLogin.settingPasswordSuccess')
                    });
                    this.isLoading = false;
                };
                let errorCallback = () => {
                    this.isLoading = false;
                };

                let payload = {
                    data: {
                        token: this.tokenSettingPassword,
                        password: this.password
                    },
                    successCallback,
                    errorCallback
                };
                this.$store.dispatch('auth/addPasswordUser', payload);
            }
        },
        validate(field) {
            let check = true;
            if (field === 'email' || !field) {
                if (!validRequired(this.email)) {
                    this.errorInfo.email = this.$t('pageLogin.errorMail');
                    check = false;
                } else if (!validEmail(this.email)) {
                    this.errorInfo.email = this.$t('pageLogin.errorMailFormat');
                    check = false;
                } else {
                    this.errorInfo.email = '';
                }
            }
            if (field === 'password' || !field) {
                if (!validRequired(this.password)) {
                    this.errorInfo.password = this.$t('pageLogin.errorPass');
                    check = false;
                } else if (this.password && !validDuplicator(this.password)) {
                    this.errorInfo.password = this.$t('pageLogin.passSame');
                    check = false;
                } else if (this.password && (!validPassword(this.password) || this.password.length < 8 || this.password.length > 32)) {
                    this.errorInfo.password = this.$t('pageLogin.passFormat');
                    check = false;
                } else {
                    this.errorInfo.password = '';
                }
            }

            if (field === 'rePassword' || !field) {
                if (!validRequired(this.rePassword)) {
                    this.errorInfo.rePassword = this.$t('pageLogin.errorRePass');
                    check = false;
                } else if (this.rePassword !== this.password) {
                    this.errorInfo.rePassword = this.$t('pageLogin.notMatch');
                    check = false;
                } else {
                    this.errorInfo.rePassword = '';
                }
            }

            return check;
        }
    }
};
</script>
<style lang="scss" scoped>
.login-page {
    &__bg {
        background-image: url('../../assets/images/12-8.jpg');
    }
}
</style>
